import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { CIRCUIT_DEPARTURE_AIRPORTS_MODULE, DEFAULT_COLUMN } from "../constants/flightParamsConstants";

export const setDepartureAirportsPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: CIRCUIT_DEPARTURE_AIRPORTS_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
